// src/pages/Accounting/Reports/AccountList/components/EmptyState.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';

export default function EmptyState() {
  const navigate = useNavigate();
  return (
    <div className="py-16 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 text-ink4 mb-3">
        <FileText size={48} strokeWidth={1.5} />
      </div>
      <h4 className="text-[15px] font-bold text-ink m-0 mb-1.5">No accounts yet</h4>
      <p className="text-[12.5px] text-ink3 m-0 mb-4 max-w-[280px] mx-auto">
        Add your first account to see this report fill in.
      </p>
      <button
        type="button"
        onClick={() => navigate('/accounting/chart-of-accounts')}
        className="bg-teal-dark text-white text-[12px] font-bold px-4 py-2 rounded-md border-none cursor-pointer hover:brightness-110"
      >
        Add an account
      </button>
    </div>
  );
}